import contractReportingApi from "../../api/contractReporting";

const state = {
  contracts: {
    contractStageCounts: [],
    standardStageAverages: [],
    nonStandardStageAverages: [],
    completedContracts: [],
    expiringContracts: []
  }
};

const getters = {};

const actions = {
  getContractStageCounts(context) {
    contractReportingApi
      .getContractStageCount()
      .then(function(response) {
        context.commit("updateContractStageCounts", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getStandardStageAverages(context) {
    contractReportingApi
      .getContractTimeAverages("Standard")
      .then(function(response) {
        context.commit("updateStandardStageAverages", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getNonStandardStageAverages(context) {
    contractReportingApi
      .getContractTimeAverages("Non-Standard")
      .then(function(response) {
        context.commit("updateNonStandardStageAverages", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getCompletedContracts(context) {
    contractReportingApi
      .getCompletedContracts()
      .then(function(response) {
        context.commit("updateCompletedContracts", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getExpiringContracts(context, payload) {
    contractReportingApi
      .getExpiringContracts(payload.startDate, payload.endDate)
      .then(function(response) {
        context.commit("updateExpiringContracts", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};

const mutations = {
  updateContractStageCounts(state, value) {
    state.contracts.contractStageCounts = value;
  },

  updateStandardStageAverages(state, value) {
    state.contracts.standardStageAverages = value;
  },

  updateNonStandardStageAverages(state, value) {
    state.contracts.nonStandardStageAverages = value;
  },

  updateCompletedContracts(state, value) {
    state.contracts.completedContracts = value;
  },

  updateExpiringContracts(state, value) {
    state.contracts.expiringContracts = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
